module.exports = __webpack_public_path__ + "assets/img/family_dance.74039037.jpg";